import { render, staticRenderFns } from "./AddCompact.vue?vue&type=template&id=2e1e9aa0&"
import script from "./AddCompact.vue?vue&type=script&lang=js&"
export * from "./AddCompact.vue?vue&type=script&lang=js&"
import style0 from "./AddCompact.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports